import React from 'react';
import { useLocation } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useStudioNavGroups } from './LeftSidebarContent';

/** Deliberately NOT an `<h1>` — pages render their own. Renders nothing for routes outside the nav. */
export function HeaderTitle() {
  const { groups } = useStudioNavGroups();
  const { pathname } = useLocation();
  const { t } = useTranslation();

  let group: string | undefined;
  let title: string | undefined;
  for (const g of groups) {
    const item = g.items.find((it) => it.active);
    if (item) {
      group = g.label;
      title = item.label;
      break;
    }
  }
  if (!title && pathname.startsWith('/app/history')) title = t('nav.my_attempts', 'My attempts');
  if (!title) return null;

  return (
    <div className="flex min-w-0 items-center gap-2">
      {group && (
        <>
          <span className="hidden shrink-0 truncate text-sm text-muted-foreground lg:inline">
            {group}
          </span>
          <ChevronRight
            className="hidden h-3.5 w-3.5 shrink-0 text-muted-foreground/50 lg:inline"
            aria-hidden
          />
        </>
      )}
      <span className="truncate text-sm font-medium text-foreground">{title}</span>
    </div>
  );
}

export default HeaderTitle;
